var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732244 0.732225C-0.244081 1.70855 -0.244081 3.29145 0.732244 4.26777L9.69509 13.2306L0.732244 22.1936C-0.244081 23.1698 -0.244081 24.7528 0.732244 25.7291C1.70854 26.7053 3.29147 26.7053 4.26777 25.7291L13.2306 16.7661L22.1936 25.7291C23.1698 26.7053 24.7528 26.7053 25.7291 25.7291C26.7053 24.7528 26.7053 23.1698 25.7291 22.1936L16.7661 13.2306L25.7291 4.2678C26.7053 3.2915 26.7053 1.70858 25.7291 0.732275C24.7526 -0.24405 23.1698 -0.24405 22.1936 0.732275L13.2306 9.69508L4.26777 0.732225C3.29147 -0.244075 1.70854 -0.244075 0.732244 0.732225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.26d4e5be1d7f08aa6b4b769d5ac8f43c.svg";
export { ForwardRef as ReactComponent };